import Nav from './components/nav';
import Home from './controllers/home';
import Page from './controllers/page';

document.addEventListener('DOMContentLoaded', () => {
  new Nav();

  if (document.body.classList.contains('home')) {
    new Home();
  } else {
    new Page();
  }
});